export default __webpack_public_path__ + "static/media/portfolio-unraf-1.05e8750b.png";